module.exports = __webpack_public_path__ + "img/vision-bg.8caa323a.svg";